import { ownersDuckCreator } from 'axl-ducks';

export default ownersDuckCreator();
